export * from './consent-details-overview.component'
export * from './consent-details-overview-routing.module'
